<div *ngIf="faqs != null" class="card bg-light">
  <div class="card-body">
    <form (ngSubmit)="filterFaqs()">
      <div class="d-flex d-inline">
        <div class="col-md-5 ">
          <select class="form-control select-bidit" id="faqSelectedCategory" name="faqSelectedCategory"
                  [(ngModel)]="this.selected">
            <option [ngValue]="undefined">Select Category</option>
            <option *ngFor="let category of this.faqsCategories" [ngValue]="category.categoryId">{{category.categoryName}}</option>
          </select>
        </div>
        <div class="col-md-3 ms-2">
          <input name="faqContentSearch" id="faqContentSearch" type="text" class="form-control"
                 maxlength="50" required=""
                 placeholder="Search Link"
                 [(ngModel)]="this.faqSearchText">
        </div>
        <button type="submit" class="ms-2 btn btn-bidit-action" i18n>Apply Filter</button>
        <button type="button" class="ms-2 btn btn-bidit-action" (click)="resetFilter()" i18n>Reset</button>

      </div>
    </form>
    <table class="table table-borderless mb-4">
      <thead><tr><td class="border-bottom-0"></td></tr></thead>
      <tbody *ngFor='let faq of faqs'>
        <tr>
          <td id="{{faq.supportFaq_ID}}" class="text-bidit-primary-header" [innerHTML]="faq.supportFaq_Title"></td>
        </tr>
        <tr class="text-bidit-primary">
          <td class="border-bottom-0" [innerHTML]="faq.supportFaq_Content"></td>
        </tr>
        <tr>
            <td>
                <div *ngFor="let hyperlink of faq.hyperlinks">
                    <a target="_blank" href="{{hyperlink.supportFaqHyperlink_Path}}">{{hyperlink.supportFaqHyperlink_Description}}</a>
                </div>
            </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
